import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { ContextWindowLookup } from '@inference.engine/agentic-ui/components';
import { modelsQueryOptions } from '../api/queries';

/** Looks a model's context window up in the model catalogue, once it has loaded. */
export function useContextWindowFor(): ContextWindowLookup {
  const models = useQuery(modelsQueryOptions());
  return useCallback(
    (modelId: string) => models.data?.find((m) => m.id === modelId)?.contextWindow,
    [models.data],
  );
}
